import { Add as AddPage } from './Add';

export default AddPage;
